import _classCallCheck from "/Users/marklesbirel/Documents/GitHub/ManualProWeb/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/marklesbirel/Documents/GitHub/ManualProWeb/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _get from "/Users/marklesbirel/Documents/GitHub/ManualProWeb/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _getPrototypeOf from "/Users/marklesbirel/Documents/GitHub/ManualProWeb/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/marklesbirel/Documents/GitHub/ManualProWeb/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/Users/marklesbirel/Documents/GitHub/ManualProWeb/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/**
 * @license Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module image/imagetextalternative/imagetextalternativeui
 */
import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import ButtonView from '@ckeditor/ckeditor5-ui/src/button/buttonview';
import clickOutsideHandler from '@ckeditor/ckeditor5-ui/src/bindings/clickoutsidehandler';
import TextAlternativeFormView from './ui/textalternativeformview';
import ContextualBalloon from '@ckeditor/ckeditor5-ui/src/panel/balloon/contextualballoon';
import textAlternativeIcon from '@ckeditor/ckeditor5-core/theme/icons/low-vision.svg';
import { repositionContextualBalloon, getBalloonPositionData } from '../image/ui/utils';
import { getSelectedImageWidget } from '../image/utils';
/**
 * The image text alternative UI plugin.
 *
 * The plugin uses the {@link module:ui/panel/balloon/contextualballoon~ContextualBalloon}.
 *
 * @extends module:core/plugin~Plugin
 */

var ImageTextAlternativeUI = /*#__PURE__*/function (_Plugin) {
  _inherits(ImageTextAlternativeUI, _Plugin);

  var _super = _createSuper(ImageTextAlternativeUI);

  function ImageTextAlternativeUI() {
    _classCallCheck(this, ImageTextAlternativeUI);

    return _super.apply(this, arguments);
  }

  _createClass(ImageTextAlternativeUI, [{
    key: "init",
    value:
    /**
     * @inheritDoc
     */
    function init() {
      this._createButton();

      this._createForm();
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "destroy",
    value: function destroy() {
      _get(_getPrototypeOf(ImageTextAlternativeUI.prototype), "destroy", this).call(this); // Destroy created UI components as they are not automatically destroyed (see ckeditor5#1341).


      this._form.destroy();
    }
    /**
     * Creates a button showing the balloon panel for changing the image text alternative and
     * registers it in the editor {@link module:ui/componentfactory~ComponentFactory ComponentFactory}.
     *
     * @private
     */

  }, {
    key: "_createButton",
    value: function _createButton() {
      var _this = this;

      var editor = this.editor;
      var t = editor.t;
      editor.ui.componentFactory.add('imageTextAlternative', function (locale) {
        var command = editor.commands.get('imageTextAlternative');
        var view = new ButtonView(locale);
        view.set({
          label: t('Change image text alternative'),
          icon: textAlternativeIcon,
          tooltip: true
        });
        view.bind('isEnabled').to(command, 'isEnabled');

        _this.listenTo(view, 'execute', function () {
          _this._showForm();
        });

        return view;
      });
    }
    /**
     * Creates the {@link module:image/imagetextalternative/ui/textalternativeformview~TextAlternativeFormView}
     * form.
     *
     * @private
     */

  }, {
    key: "_createForm",
    value: function _createForm() {
      var _this2 = this;

      var editor = this.editor;
      var view = editor.editing.view;
      var viewDocument = view.document;
      /**
       * The contextual balloon plugin instance.
       *
       * @private
       * @member {module:ui/panel/balloon/contextualballoon~ContextualBalloon}
       */

      this._balloon = this.editor.plugins.get('ContextualBalloon');
      /**
       * A form containing a textarea and buttons, used to change the `alt` text value.
       *
       * @member {module:image/imagetextalternative/ui/textalternativeformview~TextAlternativeFormView}
       */

      this._form = new TextAlternativeFormView(editor.locale); // Render the form so its #element is available for clickOutsideHandler.

      this._form.render();

      this.listenTo(this._form, 'submit', function () {
        editor.execute('imageTextAlternative', {
          newValue: _this2._form.labeledInput.fieldView.element.value
        });

        _this2._hideForm(true);
      });
      this.listenTo(this._form, 'cancel', function () {
        _this2._hideForm(true);
      }); // Close the form on Esc key press.

      this._form.keystrokes.set('Esc', function (data, cancel) {
        _this2._hideForm(true);

        cancel();
      }); // Reposition the balloon or hide the form if an image widget is no longer selected.


      this.listenTo(editor.ui, 'update', function () {
        if (!getSelectedImageWidget(viewDocument.selection)) {
          _this2._hideForm(true);
        } else if (_this2._isVisible) {
          repositionContextualBalloon(editor);
        }
      }); // Close on click outside of balloon panel element.

      clickOutsideHandler({
        emitter: this._form,
        activator: function activator() {
          return _this2._isVisible;
        },
        contextElements: [this._balloon.view.element],
        callback: function callback() {
          return _this2._hideForm();
        }
      });
    }
    /**
     * Shows the {@link #_form} in the {@link #_balloon}.
     *
     * @private
     */

  }, {
    key: "_showForm",
    value: function _showForm() {
      if (this._isVisible) {
        return;
      }

      var editor = this.editor;
      var command = editor.commands.get('imageTextAlternative');
      var labeledInput = this._form.labeledInput;

      if (!this._isInBalloon) {
        this._balloon.add({
          view: this._form,
          position: getBalloonPositionData(editor)
        });
      } // Make sure that each time the panel shows up, the field remains in sync with the value of
      // the command. If the user typed in the input, then canceled the balloon (`labeledInput#value`
      // stays unaltered) and re-opened it without changing the value of the command, they would see the
      // old value instead of the actual value of the command.
      // https://github.com/ckeditor/ckeditor5-image/issues/114


      labeledInput.fieldView.value = labeledInput.fieldView.element.value = command.value || '';

      this._form.labeledInput.fieldView.select();
    }
    /**
     * Removes the {@link #_form} from the {@link #_balloon}.
     *
     * @param {Boolean} [focusEditable=false] Controls whether the editing view is focused afterwards.
     * @private
     */

  }, {
    key: "_hideForm",
    value: function _hideForm(focusEditable) {
      if (!this._isInBalloon) {
        return;
      } // Blur the input element before removing it from DOM to prevent issues in some browsers.
      // See https://github.com/ckeditor/ckeditor5/issues/1501.


      if (this._form.focusTracker.isFocused) {
        this._form.saveButtonView.focus();
      }

      this._balloon.remove(this._form);

      if (focusEditable) {
        this.editor.editing.view.focus();
      }
    }
    /**
     * Returns `true` when the {@link #_form} is the visible view in the {@link #_balloon}.
     *
     * @private
     * @type {Boolean}
     */

  }, {
    key: "_isVisible",
    get: function get() {
      return this._balloon.visibleView === this._form;
    }
    /**
     * Returns `true` when the {@link #_form} is in the {@link #_balloon}.
     *
     * @private
     * @type {Boolean}
     */

  }, {
    key: "_isInBalloon",
    get: function get() {
      return this._balloon.hasView(this._form);
    }
  }], [{
    key: "requires",
    get:
    /**
     * @inheritDoc
     */
    function get() {
      return [ContextualBalloon];
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "pluginName",
    get: function get() {
      return 'ImageTextAlternativeUI';
    }
  }]);

  return ImageTextAlternativeUI;
}(Plugin);

export { ImageTextAlternativeUI as default };